// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".searchContactForm[data-v-d7cb894a]{margin-top:3rem}.searchContactForm__text[data-v-d7cb894a]{color:#171933;font-size:1.8rem;line-height:2.6rem;margin-bottom:2rem}.searchContactForm__form[data-v-d7cb894a]{max-width:60rem}.searchContactForm__button[data-v-d7cb894a],.searchContactForm__checkbox[data-v-d7cb894a]{margin-top:20px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
